import { getData } from '../../common/getData';
import { createHeaders } from '../../common/lib/createHeaders';

import { getBaseUrl } from '../../common/getBaseUrl';
import { ApiResponse } from '../../types/ApiResponse';
import { GrunduppgifterDto } from '../model/GrunduppgifterDto';
import { LedningDto } from '../model/LedningDto';
import { ForetagTransactions } from '../types/ForetagTransactions';

const port = '8557';
const path = '/api/foretag/v1';

export const getGrunduppgifter = (
  organisationsnummer: string,
  kundmarke?: string
): Promise<ApiResponse<GrunduppgifterDto>> =>
  getData(
    `${getBaseUrl(
      path,
      port
    )}/grunduppgifter/organisationsnummer/${organisationsnummer}`,
    createHeaders(undefined, kundmarke)
  );

export const getLedning = (
  organisationsnummer: string,
  kundmarke?: string
): Promise<ApiResponse<LedningDto>> =>
  getData(
    `${getBaseUrl(
      path,
      port
    )}/ledning/organisationsnummer/${organisationsnummer}`,
    createHeaders(undefined, kundmarke)
  );

export const getUserPermission = (): Promise<
  ApiResponse<{ transaktioner: ForetagTransactions[] }>
> => getData(`${getBaseUrl(path, port)}/transaktioner`, createHeaders());

